

import { type ForwardRefExoticComponent, forwardRef } from 'react';

import { BannerAction } from './banner-action';
import { BannerBody } from './banner-body';
import { BannerClose } from './banner-close';
import { BannerIcon } from './banner-icon';
import { BannerRoot } from './banner-root';
import type { BannerPropsInterface } from './types/banner.types';

/**
 * @since 7.13.0
 */

export const Banner = forwardRef<HTMLDivElement, BannerPropsInterface>(
  (props: BannerPropsInterface, forwardedRef) => {
    const { actionButton, children, closeButton, ...rest } = props;

    return (
      <Banner.Root ref={forwardedRef} {...rest}>
        <Banner.Body>{children}</Banner.Body>
        {actionButton ? <Banner.Action>{actionButton}</Banner.Action> : null}
        {closeButton ? <Banner.Close asChild>{closeButton}</Banner.Close> : null}
      </Banner.Root>
    );
  },
) as ForwardRefExoticComponent<BannerPropsInterface> & {
  Root: typeof BannerRoot;
  Action: typeof BannerAction;
  Body: typeof BannerBody;
  Close: typeof BannerClose;
  Icon: typeof BannerIcon;
};

Banner.Root = BannerRoot;
Banner.Action = BannerAction;
Banner.Body = BannerBody;
Banner.Close = BannerClose;
Banner.Icon = BannerIcon;

Banner.displayName = 'Banner';
